// export const apiUrl = "https://ktweb04ar.herokuapp.com";
// export const apiUrl = "https://demo.kabaditechno.com";
// export const apiUrl = "http://salty-ravine-75208.herokuapp.com";
// export const apiUrl = "https://ip.kabaditechno.com";
// export const apiUrl = "https://api.kabaditechno.com";
// export const apiUrl = "https://apis.kabaditechno.com";
export const apiUrl = "https://apis.kabaditechno.com";
